// @ts-nocheck

import { createSelector } from 'reselect';

import { type StateType } from '../../../states';

const emptyObj = {};
const emptyArray: [] = [];

export const selectMPMiscState = createSelector(
  (state: StateType) => state.mp.misc ?? emptyObj,
  (miscState) => miscState,
);

export const selectMPTmpNotifications = createSelector(
  selectMPMiscState,
  (misc) => misc.tmpNotifications ?? emptyArray,
);
